/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgResetVariable = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m11.506 14 1.515 2.366L15.728 14h2.5l-4.147 3.897 2.537 4.048h-2.386l-1.76-2.687-2.954 2.687H7l4.392-4.237L9.045 14zm8.828 2.439 1.851.758a11.04 11.04 0 0 1-2.342 3.562l-.279.274-1.375-1.455a9.04 9.04 0 0 0 2.145-3.14zm-16.587-.806a9.04 9.04 0 0 0 1.94 2.824l.279.264-1.342 1.487a11.055 11.055 0 0 1-2.547-3.417l-.163-.356zM23 13.027c0 .594-.047 1.181-.14 1.76l-.078.432-1.96-.396c.095-.47.152-.948.171-1.432l.007-.364zm-20-1c0 .487.038.969.114 1.442l.064.353-1.96.397a11.048 11.048 0 0 1-.21-1.748L1 12.027zM5 2v3.016C6.84 2.856 8.648 2 12 2c5.979 0 10.843 4.782 10.996 10.738l.004.289h-2c0-4.982-4.03-9.022-9-9.022-3.014 0-4.316.734-6.034 3.007H10v2.005H3V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgResetVariable as ResetVariable };
